import { Button } from '../../ui/Button/Button';

type AccountSaveProps = {
  handleSave: VoidFunction;
  handleCancel: VoidFunction;
  disableSave: boolean;
  buttonText?: string;
};

export function AccountSave({
  handleSave,
  handleCancel,
  disableSave,
  buttonText
}: AccountSaveProps) {
  return (
    <div className="sticky bottom-0 flex justify-between pt-5 bg-white border-t border-gray-150 mt-auto">
      <Button
        onClick={handleCancel}
        buttonClassName="flex items-center py-[9px] px-[17px] h-[38px] text-gray-800 text-sm font-medium border border-gray-200 rounded-full shadow-sm hover:bg-gray-250 hover:text-gray-700 outline-none"
      >
        Cancel
      </Button>
      <Button
        onClick={handleSave}
        buttonClassName="flex items-center py-[9px] px-[17px] h-[38px] text-cyan-950 text-sm font-medium bg-cyan-300 shadow-sm rounded-full ml-auto disabled:text-gray-200 disabled:bg-gray-100 disabled:border-0 hover:bg-cyan-500 hover:text-cyan-950 focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-cyan-500 outline-none"
        disabled={disableSave}
      >
        {buttonText}
      </Button>
    </div>
  );
}
